import "./StyleDataUndefaind.css"

function DataUndefined ( {text} ) {


    return(
        <>
            <div className="data__undef">
                {text}
            </div>
        </>
    )
}

export default DataUndefined